// removed by extract-text-webpack-plugin
module.exports = {"msignaturepad":"assigneeSelect__msignaturepad___31rID","m-signature-pad--body":"assigneeSelect__m-signature-pad--body___3gsxL","m-signature-pad--footer":"assigneeSelect__m-signature-pad--footer___2lJSi","description":"assigneeSelect__description___2zrPS","button":"assigneeSelect__button___1-gT3","clear":"assigneeSelect__clear___14v6E","save":"assigneeSelect__save___DTHmd","m-signature-pad":"assigneeSelect__m-signature-pad___3BOXV","github":"assigneeSelect__github___1P0r6","label":"assigneeSelect__label___3GMy2"};


//////////////////
// WEBPACK FOOTER
// ./client/app/shared/components/formElements/AssigneeSelect/assigneeSelect.scss
// module id = 65/N
// module chunks = client